import { IconButton } from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import { AdminItemsRow } from "modules/agentMySecurity/components/admin/admin.styled";


export default function AdminGroup({ indexItem, deleteIndex }) {
    return (
        <AdminItemsRow>
            <div className="unexpanded-row-container">
                <div className="row-items">
                    <p className="row-item">{indexItem}</p>
                </div>
                <div className="row-buttons">
                    <IconButton
                        aria-label="send prompt"
                        onClick={() => deleteIndex(indexItem)}
                        edge="end"
                        className="me-1 icon-button"
                    >
                        <DeleteIcon />
                    </IconButton>
                </div>
            </div>
        </AdminItemsRow>
    );
}
